'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;
exports.experienceShopRegister = experienceShopRegister;
exports.loadShopInfo = loadShopInfo;
exports.infoChangeSubmit = infoChangeSubmit;
exports.registerShop = registerShop;
exports.registerShopSubmit = registerShopSubmit;
exports.addressInfo = addressInfo;
exports.getProducts = getProducts;
exports.getProductDetails = getProductDetails;
exports.getMembers = getMembers;
exports.getMemberDetails = getMemberDetails;
exports.getSellings = getSellings;
exports.getCommission = getCommission;
exports.getPromotions = getPromotions;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by Administrator on 2016/6/29.
 */
var SHOPREGISTER = 'goeasy-crafts/experienceShop/SHOPREGISTER';
var SHOPREGISTER_SUCCESS = 'goeasy-crafts/experienceShop/SHOPREGISTER_SUCCESS';
var SHOPREGISTER_FAIL = 'goeasy-crafts/experienceShop/SHOPREGISTER_FAIL';

// LOADSHOPINFO, LOADSHOPINFO_SUCCESS, LOADSHOPINFO_FAIL
var LOADSHOPINFO = 'goeasy-crafts/experienceShop/LOADSHOPINFO';
var LOADSHOPINFO_SUCCESS = 'goeasy-crafts/experienceShop/LOADSHOPINFO_SUCCESS';
var LOADSHOPINFO_FAIL = 'goeasy-crafts/experienceShop/LOADSHOPINFO_FAIL';
// REGISTER, REGISTER_SUCCESS, REGISTER_FAIL
var REGISTER = 'goeasy-crafts/experienceShop/REGISTER';
var REGISTER_SUCCESS = 'goeasy-crafts/experienceShop/REGISTER_SUCCESS';
var REGISTER_FAIL = 'goeasy-crafts/experienceShop/REGISTER_FAIL';

var INFOCHANGESUBMIT = 'goeasy-crafts/experienceShop/INFOCHANGESUBMIT';
var INFOCHANGESUBMIT_SUCCESS = 'goeasy-crafts/experienceShop/INFOCHANGESUBMIT_SUCCESS';
var INFOCHANGESUBMIT_FAIL = 'goeasy-crafts/experienceShop/INFOCHANGESUBMIT_FAIL';

var GETADDRESS = 'goeasy-crafts/experienceShop/GETADDRESS';
var GETADDRESS_SUCCESS = 'goeasy-crafts/experienceShop/GETADDRESS_SUCCESS';
var GETADDRESS_FAIL = 'goeasy-crafts/experienceShop/GETADDRESS_FAIL';

var GETMEMBERS = 'goeasy-crafts/experienceShop/GETMEMBERS';
var GETMEMBERS_SUCCESS = 'goeasy-crafts/experienceShop/GETMEMBERS_SUCCESS';
var GETMEMBERS_FAIL = 'goeasy-crafts/experienceShop/GETMEMBERS_FAIL';

var GETMEMBERDETAILS = 'goeasy-crafts/experienceShop/GETMEMBERDETAILS';
var GETMEMBERDETAILS_SUCCESS = 'goeasy-crafts/experienceShop/GETMEMBERDETAILS_SUCCESS';
var GETMEMBERDETAILS_FAIL = 'goeasy-crafts/experienceShop/GETMEMBERDETAILS_FAIL';

var GETPRODUCTS = 'goeasy-crafts/experienceShop/GETPRODUCTS';
var GETPRODUCTS_SUCCESS = 'goeasy-crafts/experienceShop/GETPRODUCTS_SUCCESS';
var GETPRODUCTS_FAIL = 'goeasy-crafts/experienceShop/GETPRODUCTS_FAIL';

var GETPRODUCTDETAILS = 'goeasy-crafts/experienceShop/GETPRODUCTDETAILS';
var GETPRODUCTDETAILS_SUCCESS = 'goeasy-crafts/experienceShop/GETPRODUCTDETAILS_SUCCESS';
var GETPRODUCTDETAILS_FAIL = 'goeasy-crafts/experienceShop/GETPRODUCTDETAILS_FAIL';

var GETSELLINGS = 'goeasy-crafts/experienceShop/GETSELLINGS';
var GETSELLINGS_SUCCESS = 'goeasy-crafts/experienceShop/GETSELLINGS_SUCCESS';
var GETSELLINGS_FAIL = 'goeasy-crafts/experienceShop/GETSELLINGS_FAIL';

var GETCOMMISSIONS = 'goeasy-crafts/experienceShop/GETCOMMISSIONS';
var GETCOMMISSIONS_SUCCESS = 'goeasy-crafts/experienceShop/GETCOMMISSIONS_SUCCESS';
var GETCOMMISSIONS_FAIL = 'goeasy-crafts/experienceShop/GETCOMMISSIONS_FAIL';

var GETPROMOTIONS = 'goeasy-crafts/experienceShop/GETPROMOTIONS';
var GETPROMOTIONS_SUCCESS = 'goeasy-crafts/experienceShop/GETPROMOTIONS_SUCCESS';
var GETPROMOTIONS_FAIL = 'goeasy-crafts/experienceShop/GETPROMOTIONS_FAIL';

var initialState = {
  addressInfoLoaded: false
};
/*
 function analysisData(data) {
 let result = {};
 if (data instanceof Array && data.length > 0) {
 result = {...data[0]};
 }
 return result;
 }*/

function analysisAddressInfo(data, result, level, passDefValue, currentValue) {
  var retrunValue = result;
  if (!passDefValue || passDefValue === '') {
    var addressInfoArray = [];
    var defValue = void 0;
    if (data.addressData.defValue instanceof Array) {
      defValue = [].concat((0, _toConsumableArray3.default)(data.addressData.defValue));
    } else {
      defValue = ['', '', '', ''];
    }
    if (result.addressData && result.addressData.one instanceof Array) {
      addressInfoArray = result.addressData.one;
    }

    var newData = {};

    if (data.addressData) {
      newData = (0, _extends3.default)({}, data.addressData);
    }

    newData[level] = addressInfoArray;

    if (level === 'one') {
      newData.two = [];
      newData.three = [];
      newData.four = null;
    } else if (level === 'two') {
      newData.three = [];
      newData.four = null;
      defValue[0] = currentValue;
    } else if (level === 'three') {
      newData.four = null;
      defValue[1] = currentValue;
    }

    newData.defValue = defValue;

    retrunValue = newData;
  }
  return (0, _extends3.default)({}, data, { addressData: retrunValue });
}

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case SHOPREGISTER:
      return (0, _extends3.default)({}, state, {
        submitting: true
      });
    case SHOPREGISTER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        submitting: false,
        submitted: true,
        registerData: action.result,
        orderNumber: action.result.orderNumber
      });
    case SHOPREGISTER_FAIL:
      return (0, _extends3.default)({}, state, {
        submitting: false,
        submitted: false,
        data: null,
        error: action.error
      });
    case REGISTER:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case REGISTER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        registerData: action.result,
        orderNumber: action.result.orderNumber
      });
    case REGISTER_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        registerData: null,
        error: action.error
      });

    case LOADSHOPINFO:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOADSHOPINFO_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case LOADSHOPINFO_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case INFOCHANGESUBMIT:
      return (0, _extends3.default)({}, state, {
        infoChanging: true
      });
    case INFOCHANGESUBMIT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        infoChanging: false,
        infoChanged: true
      });
    case INFOCHANGESUBMIT_FAIL:
      return (0, _extends3.default)({}, state, {
        infoChanging: false,
        infoChanged: false,
        infoChangingError: action.error
      });

    case GETADDRESS:
      return (0, _extends3.default)({}, state, {
        addressGetting: true,
        addressGotten: false
      });
    case GETADDRESS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        addressGetting: false,
        addressGotten: true,
        registerData: analysisAddressInfo(state.registerData, action.result, action.level, action.defValue, action.currentValue)
      });
    case GETADDRESS_FAIL:
      return (0, _extends3.default)({}, state, {
        addressGetting: false,
        addressGotten: false,
        error: action.error
      });
    case GETMEMBERS:
      return (0, _extends3.default)({}, state, {
        membersGetting: true,
        membersGotten: false
      });
    case GETMEMBERS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        membersGetting: false,
        membersGotten: true,
        membersData: action.result
      });
    case GETMEMBERS_FAIL:
      return (0, _extends3.default)({}, state, {
        membersGetting: false,
        membersGotten: false,
        error: action.error
      });
    case GETMEMBERDETAILS:
      return (0, _extends3.default)({}, state, {
        memberDetailsGetting: true,
        memberDetailsGotten: false
      });
    case GETMEMBERDETAILS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        memberDetailsGetting: false,
        memberDetailsGotten: true,
        memberDetailsData: action.result
      });
    case GETMEMBERDETAILS_FAIL:
      return (0, _extends3.default)({}, state, {
        memberDetailsGetting: false,
        memberDetailsGotten: false,
        error: action.error
      });
    case GETPRODUCTS:
      return (0, _extends3.default)({}, state, {
        productsGetting: true,
        productsGotten: false
      });
    case GETPRODUCTS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        productsGetting: false,
        productsGotten: true,
        productsData: action.result
      });
    case GETPRODUCTS_FAIL:
      return (0, _extends3.default)({}, state, {
        productsGetting: false,
        productsGotten: false,
        error: action.error
      });
    case GETPRODUCTDETAILS:
      return (0, _extends3.default)({}, state, {
        productDetailsGetting: true,
        productDetailsGotten: false
      });
    case GETPRODUCTDETAILS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        productDetailsGetting: false,
        productDetailsGotten: true,
        productDetailsData: action.result
      });
    case GETPRODUCTDETAILS_FAIL:
      return (0, _extends3.default)({}, state, {
        productDetailsGetting: false,
        productDetailsGotten: false,
        error: action.error
      });
    case GETSELLINGS:
      return (0, _extends3.default)({}, state, {
        sellingsGetting: true,
        sellingsGotten: false
      });
    case GETSELLINGS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sellingsGetting: false,
        sellingsGotten: true,
        sellingsData: action.result
      });
    case GETSELLINGS_FAIL:
      return (0, _extends3.default)({}, state, {
        sellingsGetting: false,
        sellingsGotten: false,
        error: action.error
      });

    case GETCOMMISSIONS:
      return (0, _extends3.default)({}, state, {
        commissionsGetting: true,
        commissionsGotten: false
      });
    case GETCOMMISSIONS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        commissionsGetting: false,
        commissionsGotten: true,
        commissionsData: action.result
      });
    case GETCOMMISSIONS_FAIL:
      return (0, _extends3.default)({}, state, {
        commissionsGetting: false,
        commissionsGotten: false,
        error: action.error
      });
    case GETPROMOTIONS:
      return (0, _extends3.default)({}, state, {
        promotionsGetting: true,
        promotionsGotten: false
      });
    case GETPROMOTIONS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        promotionsGetting: false,
        promotionsGotten: true,
        promotionsData: action.result
      });
    case GETPROMOTIONS_FAIL:
      return (0, _extends3.default)({}, state, {
        promotionsGetting: false,
        promotionsGotten: false,
        error: action.error
      });
    default:
      return state;
  }
}

function experienceShopRegister() {
  return {
    types: [SHOPREGISTER, SHOPREGISTER_SUCCESS, SHOPREGISTER_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'getExperienceShop'
        }
      });
    }
  };
}

function loadShopInfo() {
  return {
    types: [LOADSHOPINFO, LOADSHOPINFO_SUCCESS, LOADSHOPINFO_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'loadShopInfo'
        }
      });
    }
  };
}

function infoChangeSubmit(data, orderNumber) {
  return {
    types: [INFOCHANGESUBMIT, INFOCHANGESUBMIT_SUCCESS, INFOCHANGESUBMIT_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'infoChange',
          data: data,
          orderNumber: orderNumber
        }
      });
    }
  };
}

function registerShop() {
  return {
    types: [REGISTER, REGISTER_SUCCESS, REGISTER_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'registerShop'
        }
      });
    }
  };
}

function registerShopSubmit(data, orderNumber) {
  // console.log(data.shopPicture);
  return {
    types: [REGISTER, REGISTER_SUCCESS, REGISTER_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'registerShopSubmit',
          orderNumber: orderNumber,
          data: data
        },
        files: data.shopPicture
      });
    }
  };
}

function addressInfo(data, level) {
  return {
    types: [GETADDRESS, GETADDRESS_SUCCESS, GETADDRESS_FAIL],
    level: level,
    defValue: data.defValue,
    currentValue: data.value,
    promise: function promise(client) {
      return client.post('/publicInfo', {
        data: {
          type: 'getAddressInfo',
          data: data
        }
      });
    }
  };
}

function getProducts(filter, page, orderInfo) {
  return {
    types: [GETPRODUCTS, GETPRODUCTS_SUCCESS, GETPRODUCTS_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'getProducts',
          filter: filter,
          page: page,
          orderInfo: orderInfo
        }
      });
    }
  };
}

function getProductDetails(productId) {
  return {
    types: [GETPRODUCTDETAILS, GETPRODUCTDETAILS_SUCCESS, GETPRODUCTDETAILS_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'getProductDetails',
          productId: productId
        }
      });
    }
  };
}

function getMembers(filter, page, orderInfo) {
  return {
    types: [GETMEMBERS, GETMEMBERS_SUCCESS, GETMEMBERS_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'getMembers',
          filter: filter,
          page: page,
          orderInfo: orderInfo
        }
      });
    }
  };
}

function getMemberDetails(filter, page, memberId, orderInfo) {
  return {
    types: [GETMEMBERDETAILS, GETMEMBERDETAILS_SUCCESS, GETMEMBERDETAILS_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'getMemberDetails',
          filter: filter,
          page: page,
          memberId: memberId,
          orderInfo: orderInfo
        }
      });
    }
  };
}

function getSellings(filter, page, orderInfo) {
  return {
    types: [GETSELLINGS, GETSELLINGS_SUCCESS, GETSELLINGS_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'getSellings',
          filter: filter,
          page: page,
          orderInfo: orderInfo
        }
      });
    }
  };
}

function getCommission(filter, page, orderInfo) {
  return {
    types: [GETCOMMISSIONS, GETCOMMISSIONS_SUCCESS, GETCOMMISSIONS_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'getCommission',
          filter: filter,
          page: page,
          orderInfo: orderInfo
        }
      });
    }
  };
}

function getPromotions(filter) {
  return {
    types: [GETPROMOTIONS, GETPROMOTIONS_SUCCESS, GETPROMOTIONS_FAIL],
    promise: function promise(client) {
      return client.post('/experienceShop', {
        data: {
          type: 'getPromotions',
          filter: filter
        }
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/experienceShop.js
 ** module id = 63
 ** module chunks = 0
 **/